var _path, _path2, _path3, _path4, _path5, _path6;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScoreMeter(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 145,
    viewBox: "0 0 285 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99994 140.939C3.99994 115.419 10.9763 91.5296 23.1259 71.0723",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.856 23.2227C54.4623 33.015 40.2858 46.1347 29.2589 61.6493",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6497 17.9012C97.527 9.60447 116.36 4.67808 136.271 4",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.877 17.9012C186.999 9.60447 168.166 4.67808 148.255 4",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.67 23.2227C230.064 33.015 244.241 46.1347 255.267 61.6493",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.526 140.939C280.526 115.419 273.55 91.5296 261.4 71.0723",
    strokeWidth: 8,
    strokeLinecap: "round",
    stroke: "#515C6F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreMeter);
export default __webpack_public_path__ + "static/media/score-meter.75b1edf7871b3f8cf5dd280be5d014d3.svg";
export { ForwardRef as ReactComponent };